const initialState = {
  resultsNotificationsEmails: [],
  createNotificationsEmails: [],
  updateNotificationsEmails: [],
  deleteNotificationsEmails: [],
  loading: false
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "GET_NOTIFICATIONS_EMAILS":
    case "CREATE_NOTIFICATIONS_EMAILS":
    case "UPDATE_NOTIFICATIONS_EMAILS":
    case "DELETE_NOTIFICATIONS_EMAILS":
      newState.loading = true;
      break;
    case "RESPONSE_GET_NOTIFICATIONS_EMAILS":
      newState.resultsNotificationsEmails = action.value;
      newState.loading = false;
      break;
    case "RESPONSE_CREATE_NOTIFICATIONS_EMAILS":
      newState.createNotificationsEmails = action.value;
      newState.loading = false;
      break;
    case "RESPONSE_UPDATE_NOTIFICATIONS_EMAILS":
      newState.updateNotificationsEmails = action.value;
      newState.loading = false;
      break;
    case "RESPONSE_DELETE_NOTIFICATIONS_EMAILS":
      newState.deleteNotificationsEmails = action.value;
      newState.loading = false;
      break;
    case "RESET_NOTIFICATIONS_EMAILS_RESPONSES":
      newState.resultsNotificationsEmails = [];
      newState.createNotificationsEmails = [];
      newState.updateNotificationsEmails = [];
      newState.deleteNotificationsEmails = [];
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
